'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDefaultType, getDisplayName, getModuleIcon, getIsModuleEditable, getIsGlobalModuleGroupOrPartial, getModuleById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsAdvancedModuleWithoutAccess, getModuleHasPaymentsFieldWithoutAccess, getModuleHasPersonalizationTokensWithoutAccess } from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getIsModuleStyleable } from 'ContentEditorUI/redux/selectors/styleSelectors';
import { BaseResponsiveToolbar, buildActionsForModuleInFlexColumn } from './BaseResponsiveToolbar';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { shouldShowEditModuleOnSelected } from 'InpageEditorUI/lib/toolbarUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  let newProps = {};
  if (ownProps.id) {
    const module = getModuleById(state, ownProps.id);
    newProps = {
      moduleType: getDefaultType(state, ownProps.id),
      moduleIcon: getModuleIcon(state, ownProps.id),
      isGlobal: getIsGlobalModuleGroupOrPartial(state, ownProps.id),
      displayName: getDisplayName(state, ownProps.id),
      isEditable: getIsModuleEditable(state, ownProps.id),
      isStyleable: getIsModuleStyleable(state, ownProps.id),
      isAdvancedModuleWithoutAccess: getIsAdvancedModuleWithoutAccess(state, module),
      isPaymentsModuleWithoutAccess: getModuleHasPaymentsFieldWithoutAccess(state, module),
      hasPersonalizationTokenWithoutAccess: getModuleHasPersonalizationTokensWithoutAccess(state, module),
      selectedItemId: getSelectedItemId(state),
      isPatagoniaSidebarCollapsed: getIsPatagoniaSidebarCollapsed(state)
    };
  }
  newProps.isInMobileEditingMode = getIsInNonDefaultBreakpointMode(state);
  return newProps;
};
class ResponsiveToolbarInFlexColumn extends Component {
  render() {
    const {
      id,
      displayName,
      moduleType,
      moduleIcon,
      top,
      left,
      toolbarHeight,
      onHandleMouseDown,
      onDropdownOpenChange,
      responsiveSize,
      dispatch,
      bus,
      isGlobal,
      isEditable,
      isStyleable,
      isFixedPosition,
      isInMobileEditingMode,
      isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess,
      selectedItemId,
      isPatagoniaSidebarCollapsed
    } = this.props;
    const isSelectedItem = id === selectedItemId;
    const showEditModuleOnSelected = shouldShowEditModuleOnSelected({
      isPatagoniaSidebarCollapsed,
      moduleType
    });
    return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
      moduleIcon: moduleIcon,
      actions: buildActionsForModuleInFlexColumn({
        moduleId: id,
        moduleType,
        isInMobileEditingMode,
        dispatch,
        bus,
        isGlobal,
        isEditable,
        isStyleable,
        isAdvancedModuleWithoutAccess,
        isSelectedItem,
        isPaymentsModuleWithoutAccess,
        hasPersonalizationTokenWithoutAccess
      }),
      onHandleMouseDown: onHandleMouseDown,
      onDropdownOpenChange: onDropdownOpenChange,
      style: {
        top,
        left,
        toolbarHeight,
        position: isFixedPosition ? 'fixed' : undefined
      },
      isGlobal: isGlobal,
      responsiveSize: responsiveSize,
      handleTooltip: displayName,
      isAdvancedModuleWithoutAccess: isAdvancedModuleWithoutAccess,
      isPaymentsModuleWithoutAccess: isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess: hasPersonalizationTokenWithoutAccess,
      isSelectedItem: isSelectedItem,
      showEditModuleOnSelected: showEditModuleOnSelected
    });
  }
}
ResponsiveToolbarInFlexColumn.propTypes = {
  id: PropTypes.string,
  moduleType: PropTypes.string,
  moduleIcon: PropTypes.string,
  displayName: PropTypes.string,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  toolbarHeight: PropTypes.number,
  responsiveSize: PropTypes.string.isRequired,
  onHandleMouseDown: PropTypes.func,
  onDropdownOpenChange: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  bus: PropTypes.object.isRequired,
  isGlobal: PropTypes.bool,
  isEditable: PropTypes.bool,
  isStyleable: PropTypes.bool,
  isFixedPosition: PropTypes.bool,
  isInMobileEditingMode: PropTypes.bool.isRequired,
  isAdvancedModuleWithoutAccess: PropTypes.bool,
  isPaymentsModuleWithoutAccess: PropTypes.bool,
  hasPersonalizationTokenWithoutAccess: PropTypes.bool,
  selectedItemId: PropTypes.string,
  isPatagoniaSidebarCollapsed: PropTypes.bool
};
ResponsiveToolbarInFlexColumn.defaultProps = {
  responsiveSize: DEFAULT_RESPONSIVE_SIZE
};
export default connect(mapStateToProps)(ResponsiveToolbarInFlexColumn);